import React from 'react';
import Books from '../img/goddeal-books.png';
import { isWithin } from '../../../../api/utils/util-func';

// ------------------------------------------------------------
// INFO: 갓딜위크 기간 변경 시 아래 변수들 수정 필요
export const IS_DISPLAY_GODDEAL_SECTION = isWithin('2025-10-02', '2025-10-27'); // 갓딜위크 상세페이지 노출 기간

// 갓딜위크 진행 월
const MONTH = 10;

// 갓딜위크 기간
const GODDEAL_WEEK_PERIOD = '10/13(화) ~ 10/27(월)';

const textKeyColor = 'text-[#FF7400]';
const textRedColor = 'text-[#C60000]';

const bgKeyColor = 'bg-[#FFB056]';

// ------------------------------------------------------------

const GodDealWeekSectionOct = () => {
  // tailwind sm:540px md:720px
  return (
    <>
      <div className="bg-[#1D1D1D] px-5 pt-10 sm:px-0 sm:pt-20">
        <div className="m-auto flex w-full max-w-[520px] flex-col gap-10">
          <div className="text-center text-base text-white sm:text-xl">
            주일학교 아이들에게 가장 합리적인 가격으로
            <br />
            <span className={`font-bold ${textKeyColor}`}>1학생 1교재</span>를
            선물할 수 있는
            <br />
            <span className={`font-bold ${textKeyColor}`}>매 월 단 일주일</span>
            의 기회를 놓치지 마세요!
          </div>

          <section>
            <div
              className={`text-center text-3xl font-extrabold ${textKeyColor} sm:text-[42px]`}
            >
              {MONTH}월 주일학교 갓딜위크!
            </div>
            <div className="mt-1 flex w-full items-center justify-center sm:mt-3">
              <GodDealWeekTitle />
            </div>
          </section>
          <img src={Books} alt="주일학교 갓딜위크 교재" className="w-full" />
        </div>
      </div>

      <div className={`w-full ${bgKeyColor} px-5 py-8 sm:px-0 sm:py-10`}>
        <div className="m-auto flex w-full max-w-[520px] flex-col gap-5">
          <div className="text-center font-['Pretendard'] text-xl font-normal sm:text-2xl">
            ✔️ 10월 최대 할인에 더해
            <br /> 영어로 감사기도를 배울 수 있는
          </div>

          <div className="text-center font-['Pretendard'] text-xl font-normal sm:text-2xl">
            <span className={`font-extrabold ${textRedColor}`}>
              ’영어로 땡스기빙'
            </span>
            교재를 주일학교
            <br />{' '}
            <span className={`font-extrabold ${textRedColor}`}>
              교재 1세트 당 1권씩 무료 증정!
            </span>
          </div>
        </div>
      </div>

      <div className="bg-[#E5E5E5] px-5 py-10 sm:py-20 md:px-0">
        <div className="m-auto flex w-full max-w-[520px] flex-col items-center gap-5 sm:gap-10">
          <div className="text-center text-3xl font-extrabold text-black sm:text-4xl">
            📣 {MONTH}월 갓딜위크 일정
          </div>
          <div className="grid grid-cols-[auto_1fr] gap-5 text-lg font-extrabold sm:text-3xl">
            <div>► 갓딜위크 기간 </div>
            <div className={`${textRedColor}`}>{GODDEAL_WEEK_PERIOD}</div>
            <div>► 구매방법 </div>
            <div className={`${textRedColor}`}>
              교육 수료자에게 <br />
              특별혜택 구매 링크 전송
            </div>
          </div>
        </div>
      </div>

      <div className={`w-full ${bgKeyColor} px-10 py-10 sm:py-20 md:px-0`}>
        <div className="m-auto flex w-full max-w-[520px] flex-col gap-5">
          <section className="flex flex-col items-start text-[#43260E]">
            <div className="text-lg font-medium sm:text-2xl">
              ‘영어로 땡스기빙’
            </div>
            <div className="text-3xl font-extrabold sm:text-4xl">
              이렇게 사용해 보세요!
            </div>
          </section>

          <TextWithNumberBox number="1" text="추수감사절 특별 주간 프로그램" />
          <TextWithNumberBox
            number="2"
            text="젭스영어주일학교 개강 전 체험 수업 운영"
          />
        </div>
      </div>
    </>
  );
};

export default GodDealWeekSectionOct;

const GodDealWeekTitle = () => (
  <svg
    width="362"
    height="39"
    viewBox="0 0 724 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.2472 46.915L37.9772 31.585H73.8872L67.9022 65.5C60.6572 73.165 48.1622 77.785 34.0922 77.785C12.5672 77.785 0.177227 66.025 0.177227 45.76C0.177227 18.145 17.5022 0.609994 44.9072 0.609994C57.5072 0.609994 68.4272 5.01999 74.7272 12.58L60.9722 23.815C57.7172 19.93 51.7322 17.62 44.9072 17.62C29.7872 17.62 19.8122 27.49 19.8122 42.925C19.8122 55 25.4822 61.09 36.8222 61.09C42.5972 61.09 48.8972 59.095 53.0972 56.05L54.7772 46.915H35.2472ZM97.5877 77.155C82.0477 77.155 72.1777 68.65 72.1777 55.315C72.1777 36.31 86.1427 22.975 105.883 22.975C121.423 22.975 131.188 31.48 131.188 44.815C131.188 63.715 117.328 77.155 97.5877 77.155ZM99.4777 61.405C106.513 61.405 112.078 55.105 112.078 47.23C112.078 41.98 108.928 38.725 103.888 38.725C96.7477 38.725 91.3927 44.71 91.3927 52.795C91.3927 58.15 94.5427 61.405 99.4777 61.405ZM178.69 2.49999H198.115L185.2 76H168.19V70.435C163.255 74.845 157.9 77.05 151.705 77.05C137.215 77.05 128.395 65.605 131.23 49.645C134.065 33.58 145.51 23.08 160.21 23.08C166.51 23.08 171.13 24.97 174.07 28.645L178.69 2.49999ZM158.425 61.3C164.62 61.3 169.555 56.68 170.815 49.96C172.075 43.24 168.715 38.83 162.52 38.83C156.325 38.83 151.18 43.45 150.025 50.17C148.87 56.89 152.23 61.3 158.425 61.3ZM255.989 2.49999C275.939 2.49999 288.434 14.155 288.434 32.845C288.434 59.41 271.004 76 243.074 76H211.889L224.804 2.49999H255.989ZM246.539 58.99C259.139 58.99 268.064 48.91 268.064 34.735C268.064 25.285 262.499 19.51 253.364 19.51H242.024L235.094 58.99H246.539ZM319.482 22.975C339.222 22.975 348.777 36.94 341.427 55.315H305.412C306.042 59.41 310.242 62.14 316.332 62.14C320.742 62.14 325.257 60.67 329.457 57.94L337.227 69.28C330.297 74.845 322.947 77.155 312.447 77.155C294.072 77.155 283.782 65.815 286.617 49.645C289.557 32.635 301.737 22.975 319.482 22.975ZM317.487 37.465C312.132 37.465 308.562 40.3 306.777 45.34L306.672 45.76H325.677C326.937 40.72 323.892 37.465 317.487 37.465ZM389.191 24.13H406.201L397.066 76H380.056V70.435C375.121 74.845 369.766 77.05 363.571 77.05C349.081 77.05 340.261 65.605 343.096 49.645C345.931 33.58 357.166 23.08 371.656 23.08C378.481 23.08 383.626 25.285 387.196 29.905L389.191 24.13ZM370.291 61.3C376.486 61.3 381.421 56.68 382.681 49.96C383.941 43.24 380.581 38.83 374.386 38.83C368.191 38.83 363.046 43.45 361.891 50.17C360.736 56.89 364.096 61.3 370.291 61.3ZM402.499 76L415.519 2.49999H434.944L421.924 76H402.499ZM544.4 2.49999H567.185L526.76 76H509.435L506.495 58.15L503.03 36.415L491.48 58.15L481.085 76H463.76L450.635 2.49999H471.425L475.52 28.33L477.83 46.075L501.455 2.49999H515.315L522.245 45.655L530.75 28.33L544.4 2.49999ZM584.238 22.975C603.978 22.975 613.533 36.94 606.183 55.315H570.168C570.798 59.41 574.998 62.14 581.088 62.14C585.498 62.14 590.013 60.67 594.213 57.94L601.983 69.28C595.053 74.845 587.703 77.155 577.203 77.155C558.828 77.155 548.538 65.815 551.373 49.645C554.313 32.635 566.493 22.975 584.238 22.975ZM582.243 37.465C576.888 37.465 573.318 40.3 571.533 45.34L571.428 45.76H590.433C591.693 40.72 588.648 37.465 582.243 37.465ZM640.717 22.975C660.457 22.975 670.012 36.94 662.662 55.315H626.647C627.277 59.41 631.477 62.14 637.567 62.14C641.977 62.14 646.492 60.67 650.692 57.94L658.462 69.28C651.532 74.845 644.182 77.155 633.682 77.155C615.307 77.155 605.017 65.815 607.852 49.645C610.792 32.635 622.972 22.975 640.717 22.975ZM638.722 37.465C633.367 37.465 629.797 40.3 628.012 45.34L627.907 45.76H646.912C648.172 40.72 645.127 37.465 638.722 37.465ZM723.76 24.13L701.815 49.855L717.985 76H695.515L684.91 57.835L681.76 76H662.335L675.25 2.49999H694.675L688.165 39.775L700.765 24.13H723.76Z"
      fill="white"
    />
  </svg>
);

const TextWithNumberBox = ({
  number,
  text,
}: {
  number: string;
  text: string;
}) => (
  <div className="flex flex-row items-center gap-2 rounded-2xl bg-[#FFF2E7] py-5 pl-5 sm:gap-3 sm:px-10 sm:py-7">
    <span className="flex h-4 w-4 items-center justify-center rounded-full bg-[#FF743D] text-sm font-normal text-[#FFF2E7] sm:h-7 sm:w-7 sm:text-lg">
      {number}
    </span>
    <span className="text-sm font-semibold text-[#361800] sm:text-xl">
      {text}
    </span>
  </div>
);
